"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var promise_1 = require("../utils/promise");
var Button_1 = tslib_1.__importDefault(require("../Button"));
var defs_1 = require("./defs");
var hooks_1 = require("../utils/hooks");
function Form(_a) {
    var onSubmit = _a.onSubmit, onCancel = _a.onCancel, sizeFromProps = _a.size, layoutFromProps = _a.layout, verticalGapFromProps = _a.verticalGap, _b = _a.footer, footer = _b === void 0 ? react_1.default.createElement(Footer, null) : _b, children = _a.children, classNameFromProps = _a.className, styleFromProps = _a.style, formRef = _a.formRef, formProps = _a.formProps, as = _a.as, labelOptionsFromProps = tslib_1.__rest(_a, ["onSubmit", "onCancel", "size", "layout", "verticalGap", "footer", "children", "className", "style", "formRef", "formProps", "as"]);
    var prefix = ConfigProvider_1.usePrefix('form');
    var size = defs_1.useFormSize(sizeFromProps);
    var layout = defs_1.useFormLayout(layoutFromProps);
    var labelOptions = defs_1.useFormLabelOptions(labelOptionsFromProps);
    var verticalGap = defs_1.useFormVerticalGap(verticalGapFromProps);
    var className = classnames_1.default(prefix, utils_1.concat(prefix, 'size', size), utils_1.concat(prefix, 'layout', layout.type), classNameFromProps, formProps === null || formProps === void 0 ? void 0 : formProps.className);
    var style = tslib_1.__assign(tslib_1.__assign({}, styleFromProps), formProps === null || formProps === void 0 ? void 0 : formProps.style);
    var isMountedRef = hooks_1.useIsMounted();
    var _c = react_1.useState(false), submitting = _c[0], setSubmitting = _c[1];
    var handleSubmit = react_1.useCallback(function (e) {
        var _a;
        if (onSubmit != null) {
            e.preventDefault();
            var ret = onSubmit();
            if (promise_1.isPromise(ret)) {
                setSubmitting(true);
                var handleSubmitEnd = function () {
                    if (isMountedRef.current)
                        setSubmitting(false);
                };
                ret.then(handleSubmitEnd, handleSubmitEnd);
            }
        }
        (_a = formProps === null || formProps === void 0 ? void 0 : formProps.onSubmit) === null || _a === void 0 ? void 0 : _a.call(formProps, e);
    }, [onSubmit, formProps, isMountedRef]);
    var footerCtxValue = react_1.useMemo(function () { return ({ submitting: submitting, onCancel: onCancel }); }, [submitting, onCancel]);
    var footerStyle = (
    // inline 的情况下 footer 在主体内容右侧，因此不需要设置上间距
    layout.type !== 'inline'
        ? { marginTop: verticalGap }
        : undefined);
    return react_1.createElement(as !== null && as !== void 0 ? as : 'form', tslib_1.__assign(tslib_1.__assign({}, formProps), { ref: formRef, className: className, style: style, onSubmit: handleSubmit }), react_1.default.createElement(defs_1.sizeCtx.Provider, { value: size },
        react_1.default.createElement(defs_1.layoutCtx.Provider, { value: layout },
            react_1.default.createElement(defs_1.labelOptionsCtx.Provider, { value: labelOptions },
                react_1.default.createElement(defs_1.verticalGapCtx.Provider, { value: verticalGap },
                    react_1.default.createElement(defs_1.footerCtx.Provider, { value: footerCtxValue },
                        react_1.default.createElement("div", { className: utils_1.concat(prefix, 'body') }, children),
                        footer != null && react_1.default.createElement("div", { className: utils_1.concat(prefix, 'footer'), style: footerStyle }, footer)))))));
}
exports.default = Form;
/** 默认的 footer 实现 */
function Footer(_a) {
    var _b, _c;
    var submitText = _a.submitText, cancelText = _a.cancelText, _d = _a.submitType, submitType = _d === void 0 ? 'primary' : _d, _e = _a.cancelType, cancelType = _e === void 0 ? 'default' : _e, _f = _a.submitLoading, submitLoading = _f === void 0 ? false : _f, _g = _a.submitButtonProps, submitButtonProps = _g === void 0 ? {} : _g, _h = _a.cancelButtonProps, cancelButtonProps = _h === void 0 ? {} : _h, _j = _a.align, align = _j === void 0 ? 'left' : _j;
    var langData = ConfigProvider_1.useLangData('form');
    var prefix = ConfigProvider_1.usePrefix('form');
    var className = utils_1.concat(prefix, 'footer');
    var _k = defs_1.useFooterCtx(), submitting = _k.submitting, onCancel = _k.onCancel;
    var layout = defs_1.useFormLayout(undefined);
    var labelOptions = defs_1.useFormLabelOptions();
    var contentWrapperClassName = classnames_1.default(utils_1.concat(className, 'content'), layout.type !== 'inline' && utils_1.concat(className, 'align', align));
    // 占位，尺寸对应 FormItem 的 label，从而使得 footer 内容跟 FormItem body 部分对齐
    var labelPlaceholder = layout.type === 'horizontal' && (react_1.default.createElement("div", { className: utils_1.concat(className, 'label-placeholder'), style: {
            flexBasis: (_b = labelOptions.labelWidth) !== null && _b !== void 0 ? _b : defs_1.defaultLabelWidth,
            marginRight: (_c = labelOptions.labelGap) !== null && _c !== void 0 ? _c : defs_1.defaultLabelGapForHorizontal
        } }));
    var submitBtn = (react_1.default.createElement(Button_1.default, tslib_1.__assign({ type: submitType, htmlType: "submit", loading: submitLoading || submitting }, submitButtonProps), submitText !== null && submitText !== void 0 ? submitText : langData.submitText));
    var cancelBtn = onCancel && (react_1.default.createElement(Button_1.default, tslib_1.__assign({ type: cancelType, onClick: onCancel }, cancelButtonProps), cancelText !== null && cancelText !== void 0 ? cancelText : langData.cancelText));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        labelPlaceholder,
        react_1.default.createElement("div", { className: contentWrapperClassName },
            submitBtn,
            cancelBtn)));
}
exports.Footer = Footer;
//# sourceMappingURL=Form.js.map